

/**
 * First we will load all of this project's JavaScript dependencies.
 */


import './bootstrap';
import "@fancyapps/fancybox";
import "moment";
import './jqueryValidateExtend';
import './subscribe';
import 'owl.carousel2';
import 'fullcalendar';
import { addBackToTop } from 'vanilla-back-to-top';
import './isometric';

var BASEDIR = window.location.pathname;

var Page = function () {

	var initBackToTop = function () {
		addBackToTop({
			diameter: 56,
			backgroundColor: '#28a5b9',
			textColor: '#ffff'
		});
	};


	var initCalendar = function () {
		if (typeof events == 'undefined') {
			return;
		}
		$('.module_events .calendar').fullCalendar({
			monthNames: ['Január', 'Február', 'Március', 'Április', 'Május', 'Június', 'Július', 'Augusztus', 'Szeptember', 'Október', 'November', 'December'],
			dayNames: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
			dayNamesShort: ['Vasárnap', 'Hétfő', 'Kedd', 'Szerda', 'Csütörtök', 'Péntek', 'Szombat'],
			firstDay: 1,
			navLinks: false,
			editable: false,
			weekNumbers: false,
			eventLimit: true,
			eventLimitText: '',
			events: events,
			eventRender: function (event, element) {
				var dataToFind = event.start.format('YYYY-MM-DD');
				//console.log(dataToFind);
				$("td[data-date='" + dataToFind + "']").addClass('activeDay');
			},
			header: {
				left: '',
				center: 'title',
				right: 'prev,next'
				//weekNumbers: true
			},
			views: {
				month: {
					eventLimit: 2
				}
			}
		});

	};

	var initSearch = function () {

		$('#search-icon').click(function (e) {
            e.preventDefault();

            var win_width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
            if (win_width > 768) {
                $('#search-bar').show();
                $('#search-close').show();
                $('#search-icon').hide();
            } else {
                $('.menu_search').find('form').submit();
            }
            $('input', menuSearchInput).focus();
        });

        $('#search-close').click(function (e) {
            e.preventDefault();
            $('#search-icon').show();
            $('#search-close').hide();
            $('#search-bar').hide();
        });
    };

    var initMap = function () {

        if(!$('.animated-map').length){
            return;
        }

        let selector = $('input[type=radio][name=unit-selector]');

        let activeUnit = selector.val();

        setMapData(activeUnit);

        selector.change(function () {
            setMapData(this.value);
        });

    };

    var setMapData = function (unit) {

        let data = window.tsoData;

        let cities = {
            mosonmagyarovar: {
                show: 'text',
            },
            beregdaroc: {
                show: 'text',
            },
            vecses: {
                show: 'text',
            },
            csanadpalota: {
                show: 'text',
            },
            kiskundorozsma: {
                show: 'text',
            },
            kiskundorozsma2: {
                show: 'text',
            },
            dravaszerdahely: {
                show: 'text',
            },
            prod_sum: {
                show: 'html',
            },
            consump_sum: {
                show: 'html',
            },
            removal_sum: {
                show: 'html',
            },
            storage_sum: {
                show: 'html',
            },
            containers_sum: {
                show: 'html',
            },
            containers_ratio: {
                show: 'html',
            }
        };


        for (const property in cities) {

            let selector = ".tso-" + property;
            let lineSelector = ".map-line-" + property;
            let circleSelector = ".map-circle-" + property;
            let titleSelector = ".title-" + property;


            if (typeof data[property] === 'undefined' || typeof data[property].value[unit] === 'undefined') {

                $(selector).text('N/A');
                $(selector).removeClass('loading');

                continue;
            }

            $(lineSelector).show();

            let displayData = data[property];

            if (cities[property].show === 'text') {

                if(displayData.dir === 'IN'){
                    $(circleSelector).removeClass('out');

                    if($(lineSelector).hasClass('out')){
                        $(lineSelector).css('animation-name','dashBack');
                    }

                    $(lineSelector).removeClass('out');
                    $(circleSelector).addClass('in');
                    $(lineSelector).addClass('in');
                    $(titleSelector).removeClass('out');
                    $(titleSelector).addClass('in');
                }else{
                    $(circleSelector).removeClass('in');

                    if($(lineSelector).hasClass('in')){
                        $(lineSelector).css('animation-name','dashBack');
                    }

                    $(lineSelector).removeClass('in');
                    $(circleSelector).addClass('out');
                    $(lineSelector).addClass('out');
                    $(titleSelector).removeClass('in');
                    $(titleSelector).addClass('out');
                }

                let direction = displayData.dir === 'IN'? window.transIn : window.transOut;

                let text = `${direction} ${displayData.value[unit].value} ${displayData.value[unit].unit.text}`;
                $(selector).text(text);
            } else {
                let html = `${displayData.value[unit].value} ${displayData.value[unit].unit.html}`;
                $(selector).html(html);
            }

            $(selector).removeClass('loading');

        }

    };


    var initPageEvents = function () {

        $(document).ready(function () {
            companyMapFirstLoad();
            tilesOnLoad();

            var $trigger = "hover";

            var options = {
                placement: function (context, source) {
                    var width = jQuery('body,html').width();
                    var position = $(source).position();

                    if (width < 577) {
                        return "top";
                    }

                    return $(source).data('placement');
                },
                trigger: $trigger,
                html: true
            };

			//$('[data-toggle="tooltip"]').tooltip(options);
		});



		$(document).on("click", ".faq", function () {
			$(this).toggleClass('open');
		});

		$(document).on("click", ".lang-select", function () {
			var parent = $(this).parent();
			var selector = parent.find(".lang-list");

			if (selector.hasClass("active")) selector.removeClass('active');
			else selector.addClass('active');
		});

		$(document).on("click", ".mobile-btn", function () {
			if (!$('body').hasClass('active')) return $('body').addClass('active');
			$('body').removeClass('active');
		});



		$(document).on('click', '.faq_item', function () {
			var clickedAnswer = $(this).find('.answer');

			$('.faq_item .answer').each(function () {
				if ($(this) != clickedAnswer) {
					$(this).slideUp();
				}
			});

			if (clickedAnswer.css('display') == 'none') {
				clickedAnswer.slideDown();
			} else {
				clickedAnswer.slideUp();
			}

			var arrow = $(this).find('.arrow');

			if (arrow.hasClass('arrow_down')) {
				$('.faq_item .arrow').each(function () {
					if ($(this).hasClass('arrow_up')) {
						$(this).removeClass('arrow_up');
						$(this).addClass('arrow_down');
					}
				});

				arrow.removeClass('arrow_down');
				arrow.addClass('arrow_up');
			} else if (arrow.hasClass('arrow_up')) {
				arrow.removeClass('arrow_up');
				arrow.addClass('arrow_down');
			}
		});

		$(document).on('click', '.toggle_box_item', function () {
			var clickedAnswer = $(this).find('.details');

			$('.toggle_box_item .details').each(function () {
				if ($(this) != clickedAnswer) {
					$(this).slideUp();
				}
			});

			if (clickedAnswer.css('display') == 'none') {
				clickedAnswer.slideDown();
			} else {
				clickedAnswer.slideUp();
			}

			var arrow = $(this).find('.arrow');

			if (arrow.hasClass('arrow_down_blue')) {
				$('.faq_item .arrow').each(function () {
					if ($(this).hasClass('arrow_up_blue')) {
						$(this).removeClass('arrow_up_blue');
						$(this).addClass('arrow_down_blue');
					}
				});

				arrow.removeClass('arrow_down_blue');
				arrow.addClass('arrow_up_blue');
			} else if (arrow.hasClass('arrow_up_blue')) {
				arrow.removeClass('arrow_up_blue');
				arrow.addClass('arrow_down_blue');
			}
		});


		$(document).on('click', '.topic_1 .main_menu', function () {
			var submenu = $(this).parent().find('.submenus');

			$('.topic_1 .submenus').each(function () {
				if ($(this) != submenu) {
					$(this).slideUp();
				}
			});

			if (submenu.css('display') == 'none') {
				submenu.slideDown();
			} else {
				submenu.slideUp();
			}

			var arrow = $(this).parent().find('.arrow');

			if (arrow.hasClass('arrow_down')) {
				$('.topic_1 .arrow').each(function () {
					if ($(this).hasClass('arrow_up')) {
						$(this).removeClass('arrow_up');
						$(this).addClass('arrow_down');
					}
				});

				arrow.removeClass('arrow_down');
				arrow.addClass('arrow_up');
			} else if (arrow.hasClass('arrow_up')) {
				arrow.removeClass('arrow_up');
				arrow.addClass('arrow_down');
			}
		});


        $('input[type=radio][name=year-selector]').change(function() {
            var currentMapID = this.value;

            $('.company_history .map_container img').hide();

            $('.company_history .map_container #map' + currentMapID + '').show();
        });



		$(document).on('click', '.strategy .tiles_item', function () {
			$('.strategy .tiles_details').hide();

			var tilesID = $(this).attr('data-tiles-id');
			$('.strategy .tiles_details[data-tiles-id="' + tilesID + '"]').show();
		});

		$(document).on('click', '.questions.container .row>div>div>div', function () {
			$rel = jQuery(this).attr('rel');
			if (jQuery('#' + $rel).length > 0) {
				jQuery("html, body").animate({ scrollTop: jQuery('#' + $rel).offset().top });
			}

		});

		$('.module_gallery_with_thumbnail').each(function () {

			var owl_gallery = $('.owl-carousel.gallery', this).owlCarousel({
				loop: false,
				items: 1,
				nav: true,
				navText: ["<i class='left'></i>", "<i class='right'></i>"]
			});
			var owl_thumbnail = $('.owl-carousel.thumbnail', this).owlCarousel({
				loop: false,
				items: 5,
				nav: true,
				navText: ["<i class='left'></i>", "<i class='right'></i>"]
			});

			var $gallery = $('.owl-carousel.gallery', this);
			var $thumbnail = $('.owl-carousel.thumbnail', this);
			var $thumbnail_items = $('.owl-carousel.thumbnail .owl-item', this);
			var $obj = this;
			var $content;

			owl_gallery.on('translate.owl.carousel', function (event) {
				$('.text_container.bg-silver', $obj).addClass("translate");
			});

			owl_gallery.on('translated.owl.carousel', function (event) {
				var $index = $('.owl-item.active', $gallery).index();
				var $items_gallery = $('.owl-item', $gallery).length;
				var $items_thumbs = $('.owl-item.active', $thumbnail).length;
				owl_thumbnail.trigger('to.owl.carousel', Math.floor($index / $items_thumbs));

				$content = "";
				if ($('.containerHelper div:eq(' + $index + ')', $obj).length > 0)
					$content = $.trim($('.containerHelper div:eq(' + $index + ')', $obj).html());
				$('.text_container.bg-silver', $obj).html($content);

				if ($content == "") $('.text_container.bg-silver', $obj).addClass('no-content');
				else $('.text_container.bg-silver', $obj).removeClass('no-content');
				$('.text_container.bg-silver', $obj).removeClass("translate");
			});

			$thumbnail_items.click(function () {
				var $index = $(this).index();
				owl_gallery.trigger('to.owl.carousel', $index);
			});

			$content = "";
			if ($('.containerHelper div:eq(0)', $obj).length > 0)
				$content = $.trim($('.containerHelper div:eq(0)', $obj).html());
			$('.text_container.bg-silver', $obj).html($content);

			if ($content == "") $('.text_container.bg-silver', $obj).addClass('no-content');
			else $('.text_container.bg-silver', $obj).removeClass('no-content');

		});

		$(document).on('click', '.main_page .legend_btn', function () {
			$('.main_page .legend_details_only_mobile').toggle();
		});


		$(document).on('change', '.allasjelentkezes .cv_upload', function () {
			console.log($(this));
			var file_name = $(this).closest('.row').find('.filename');
			var icon_x = $(this).closest('.row').find('.icon_x');
			var file = $(this)[0].files[0].name;
			file_name.text(file);
			icon_x.show();
		});

		$(document).on('click', '.allasjelentkezes .file_list .icon_x', function () {
            // var $el = $('.allasjelentkezes #file');
            var $el = $(this).closest('.row').find('.cv_upload');
            $el.wrap('<form>').closest('form').get(0).reset();
            $el.unwrap();
            $(this).closest('.row').find('.filename').text('');
            $(this).hide();
        });

        var a = 0;
        var infoContainer = $('.tarsadalmiszerepvallalas .info_container');
        $(window).scroll(function () {
            if (infoContainer.length) {
                var oTop = infoContainer.offset().top - window.innerHeight;

                if (a == 0 && $(window).scrollTop() > oTop) {
                    $('.tarsadalmiszerepvallalas .info_container strong').each(function () {
                        $(this).prop('Counter', 0).animate({
                            Counter: $(this).text()
                        }, {
                            duration: 2000,
                            easing: 'swing',
                            step: function (now) {
                                $(this).text(Math.ceil(now));
                            }
                        });
                    });
                    a = 1;
                }
            }
        });

        $(document).on('click', function (event) {
            var $class = jQuery(event.target).attr('class');
            var $index = -1;
            if (typeof ($class) != "undefined") $index = $class.indexOf('png-sequence');
            if ($index == -1 && $index == -1 && jQuery('.seq-cont.active').length > 0) jQuery('.seq-cont.active').removeClass('active');
        });

        jQuery('section.sequence .seq-cont.active p').click(function () {
            jQuery('.seq-cont.active').removeClass('active');
        });

        jQuery('.mobile-menu-takaro').click(function () {
            jQuery('.mobile-btn').click();
        });

        setTimeout(function () {
            bc_bg();
        }, 1500);

        jQuery(window).resize(function () {
            bc_bg();
        });
    };

	var initValidations = function () {

		var validator = $('.cms-form').validate({
			errorClass: 'invalid-feedback', // default input error message class
			focusInvalid: true, // do not focus the last invalid input
			errorElement: 'span',
			highlight: function (element) { // hightligowl-carouselht error inputs
				$(element).closest('.form-group').addClass('is-invalid'); // set error class to the control group
			},
			errorPlacement: function (error, element) {
                element.closest('.form-group').find('.invalid-feedback').empty();
                error.appendTo(element.closest('.form-group'));
			},
			success: function (label) {
				label.closest('.form-group').removeClass('is-invalid');
				label.closest('.form-group').removeClass('is-valid');
				label.remove();
			},
		});

		$('.cms-form').find('input[type="file"]').each(function () {
			$(this).rules("add", {
				fileType: {
					types: ["pdf", "txt", "text/plain", "doc", "docx"]
				},
				maxFileSize: {
					"unit": "MB",
					"size": 2
				},
			});
		});
	};

	var bc_bg = function () {
		if (jQuery('.breadcrumb a').length > 0) {
			var $left = jQuery('.breadcrumb a:last').offset().left + jQuery('.breadcrumb a:last').outerWidth();
			jQuery('.breadcrumb').css("background-size", $left + "px 100%");
			jQuery('.breadcrumb a:last').addClass('remove');
		}
	};

	function companyMapFirstLoad() {
		$('.company_history .map_container').find('#map4').show();
		$('.company_history .label_year[data-map-id="4"]').addClass('active');
	}

	function tilesOnLoad() {
		$('.strategy .tiles_details[data-tiles-id="1"]').show();
	}



	if ($('section.vallaltiranyitas').length > 0 || $('section.international_relations').length > 0) {

		$(document).on("click", ".button_submenu", function () {
			var id = $(this).data('id');

            $('.container.submenucontent').removeClass('show');
            $('.container.submenucontent').removeClass('d-none');
            $('.container.submenucontent').hide();
            $('.container.submenucontent.item_' + id).show();

        });
    }

    function _szir($rel) {
        jQuery('.text_container.szir.active').slideUp();
        jQuery('.text_container.szir[rel=' + $rel + ']').slideDown().addClass('active');
    }

    jQuery('.scc_container .clickable-path').bind("click", function (event) {
        var $rel = jQuery(this).attr('rel');
        _szir($rel);
        return false;
    });

    $(document).on("click", ".email-cover", function () {
        var id = $(this).data('id');
        var hash = $(this).data('hash');

        $("#recaptcha-modal").attr("aria-labelledby", id);
        $("#recaptcha-modal .modal-id").val(id);
        $("#recaptcha-modal .hash").val(hash);
    });

	$('.email-form').on('submit', function (e) {
        e.preventDefault();
        let data = $(this).serialize();
        let modalId = $(this).children('input[name="modal_id"]').val();
        axios.post('/ajax/getEmailAddress', data)
            .then(function (response) {
                if (response.data) {
                    let anchor = $('a[data-id="'+ modalId +'"]');
                    anchor.attr('href', 'mailto:' + response.data[0]);
                    anchor.text(response.data[1]);

                    $.each(anchor.data(), function (key) {
                        let attr = 'data-' + key.replace(/([A-Z])/g, '-$1').toLowerCase();
                        anchor.removeAttr(attr);
                    });
                }
            }).catch(function (error) {
                console.log(error);
            });

        $('#recaptcha-modal').modal('hide');
        grecaptcha.reset();
    });


    function initCarousel() {
        $('.staff-carousel').each( function() {
            var $carousel = $(this);

            $carousel.on('initialized.owl.carousel', function(event){
                let $owlStage = $(event.target).find('.owl-stage');
                $owlStage.height($owlStage.height());
            });

            $carousel.owlCarousel({
                loop: true,
                margin: 30,
                nav: true,
                autoplay: $carousel.data('autoplay'),
                autoplayTimeout:10000,
                touchDrag:false,
                mouseDrag:false,
                navText:[
                    `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" transform="rotate(180 20 20)" fill="#00BFDC"/>
    <rect x="21.8066" y="10.8076" width="3" height="13" rx="1.5" transform="rotate(45 21.8066 10.8076)" fill="white"/>
    <rect x="23.9297" y="27.071" width="3" height="13" rx="1.5" transform="rotate(135 23.9297 27.071)" fill="white"/>
    </svg>
    `,
                    `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#00BFDC"/>
    <rect x="18.1934" y="29.1924" width="3" height="13" rx="1.5" transform="rotate(-135 18.1934 29.1924)" fill="white"/>
    <rect x="16.0703" y="12.929" width="3" height="13" rx="1.5" transform="rotate(-45 16.0703 12.929)" fill="white"/>
    </svg>
    `
                ],
                responsive: {
                    0: {
                        items: 1
                    },
                    768: {
                        items: 2
                    },
                    1200: {
                        items: 3
                    }
                }
            });
        });
    };

    function initSzechenyLogo() {
        let $logo = $('#szechenyi-logo');
        let $mobileLogo = $('#szechenyi-mobile-logo');

        window.addEventListener("scroll", function(){
            if(window.scrollY <= 40 && !$logo.hasClass('show')) {
                $logo.addClass('show');
                $mobileLogo.addClass('show');
            } else if (window.scrollY > 40 && $logo.hasClass('show')) {
                $logo.removeClass('show');
                $mobileLogo.removeClass('show');
            }
        });


    }


    return {
        //main function to initiate the module
        init: function () {
            initMap();
            initBackToTop();
            initPageEvents();
            // initValidations();
            initCalendar();
            initSearch();
            initCarousel();
            initSzechenyLogo();
        }
    };

}();

$.strPad = function (input, pad_length, pad_string, pad_type) {
	var output = input.toString();
	if (pad_string === undefined) { pad_string = ' '; }
	if (pad_type === undefined) { pad_type = 'STR_PAD_RIGHT'; }
	if (pad_type == 'STR_PAD_RIGHT') {
		while (output.length < pad_length) {
			output = output + pad_string;
		}
	} else if (pad_type == 'STR_PAD_LEFT') {
		while (output.length < pad_length) {
			output = pad_string + output;
		}
	} else if (pad_type == 'STR_PAD_BOTH') {
		var j = 0;
		while (output.length < pad_length) {
			if (j % 2) {
				output = output + pad_string;
			} else {
				output = pad_string + output;
			}
			j++;
		}
	}
	return output;
};


$(document).ready(function () {
	Page.init();

	// let modal = $('.modal');
    //
    // modal.on('shown.bs.modal', function () {});
    //
    // modal.on('hidden.bs.modal', function () {
    //     grecaptcha.reset();
    // });
});
